import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/PageHeader";
import { api } from "@/lib/api";

export default function Guides() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/guides").then(({ data }) => setItems(data));
  }, []);
  const shown = useMemo(() => items.filter((g) => (g.title + g.summary + g.category).toLowerCase().includes(q.toLowerCase())), [items, q]);

  return (
    <div data-testid="guides-page">
      <PageHeader eyebrow="Cosa faccio ora?" title="Pratiche passo passo" desc="Checklist con i link ai portali ufficiali e il confronto tra fare da soli o andare al CAF." />
      <div className="relative mb-6 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="es. ISEE, 104, multa…" className="pl-9 bg-white h-11" data-testid="guides-search-input" />
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {shown.map((g, i) => (
          <Link key={g.slug} to={`/app/guide/${g.slug}`} className="lift rounded-3xl border bg-white p-6 flex flex-col fade-up" style={{ animationDelay: `${i * 40}ms` }} data-testid={`guide-card-${g.slug}`}>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E07A5F]">{g.category}</span>
            <h3 className="mt-3 text-xl font-medium">{g.title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{g.summary}</p>
            <p className="mt-5 text-sm text-[#1E3A8A] flex items-center gap-1">{g.steps_count} passaggi <ArrowRight className="h-4 w-4" /></p>
          </Link>
        ))}
      </div>
      <p className="mt-8 text-xs text-slate-500">Costi e tempi sono indicativi e possono variare per Comune, CAF e situazione personale. Verifica sempre sui portali ufficiali.</p>
    </div>
  );
}
